<template>
  <div :id="`wtpie_${id}`" class="pie-ctn" :style="style">
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

import { derrorFactory, errorFactory, dlogFactory } from '@u/log'
const derror = derrorFactory('ChartPie', true)
const error = errorFactory('ChartPie', false)
const log = dlogFactory('ChartPie', true)

let _id = 1
export default {
  name: 'CChartPie',
  mixins: [reDrawTrigger],
  props: {
    values: {
      type: [Array],
      default: () => []
    },
    t2: {
      type: [String],
      default: ''
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    }
  },
  data() {
    _id++
    const id = `cpie_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    h() {
      const { w } = this
      return 221 / 455 * w
    },
    w() {
      const ds = this.ds
      
      const r = 455 / 1754
      derror(`[pie]computed w: ${ds}, rst: ${r * ds}`)
      return r * ds
    },
    style() {
      const { w, h, showMarginRight, zoomRatio, stripeInnerBorderC, lfs } = this
      const rst = { width: w + 'px', height: h + 'px', zoom: zoomRatio, border: `1px solid ${stripeInnerBorderC}`, borderRadius: `${Math.floor(lfs * 0.8)}px` }

      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    },
    title() {
      const { values = [], t2 } = this
      const msg = this.$t(`Insulin injection in total`)
      // const msg = this.$t(`Insulin injection in total`)
      const total = values.reduce((prev, cur) => {
        return (cur && cur.value !== undefined) ? (+cur.value + prev) : (prev)
      }, 0)
      /* eslint-disable */
      const part2 = t2 ? t2 : `(${_pretty(total.toFixed(1))}U)`
      /* eslint-enable */
      
      function _pretty(str) {
        if (/\.0/.test(str)) {
          return (+str).toFixed(0)
        }
        return str
      }
      return `${msg} ${part2}`
    }
  },
  mounted() {
    this.renderPies(false)
  },
  beforeDestroy() {
    try {
      if (this._myChart) {
        this._myChart.dispose() // 销毁echarts实例
        this._myChart = null
      }
    } catch (err) {
      error('被捕获:' + err)
    }
  },
  methods: {
    refreshTriggered() {
      derror(`CharPie ${this.id}, this.refreshTriggered`)
      this.renderPies(true)
    },
    renderPies(isUpdate = false) {
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(_val = []) {
      const { title, lfs } = this
      const values = _val.map(v => {
        return Object.assign({}, v, {
          name: this.$t(v.name)
        })
      })
      const ds = this.ds
      
      const o = {
        title: {
          padding: [(14 / 12) * lfs, 0, 0, (15 / 12 * lfs)],
          show: true,
          text: title,
          textStyle: {
            fontSize: lfs,
            color: 'black',
            fontWeight: 'bold'
          }
        },
        animation: false,
        tooltip: {
          show: false,
          trigger: 'item'
        },
        legend: {
          show: false
        },
        color: ['#D5ECFF', '#57B5FF'],
        series: [
          {
            name: 'Insulin injection',
            type: 'pie',
            radius: ['20%', '32%'],
            avoidLabelOverlap: false,
            // itemStyle: { // 会形成border、弧度
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2
            // },
            itemStyle: {
              borderRadius: 3
            },
            selectMode: true,
            selectedOffset: 5,
            showAbove: true,
            label: {
              normal: {
                show: true,
                fontSize: 12,
                position: 'outer', // 让labelLine末端对齐
                alignTo: 'labelLine', //
                distanceToLabelLine: 0,
                padding: [-20, 0, 0, 0],
                formatter: params => {
                  return `{pre|${params.value}U  (${params.percent.toFixed(0) + '%'})}\n{name| ${params.name}}\n`
                },
                rich: {
                  pre: {
                    color: '#070C12',
                    fontFamily: 'PingFang-SC-Bold',
                    fontWeight: '700',
                    fontSize: 14,
                    align: 'left',
                  },
                  name: {
                    color: '#515669',
                    fontSize: 10,
                    padding: [5, 0, 5, -4],
                    align: 'left',
                  }
                }
              },
              emphasis: {
                show: true
              }
            },
            emphasis: {
              disabled: false,
              scaleSize: 3// ,
              // label: {
              //   show: true,
              //   fontSize: 40,
              //   fontWeight: 'bold'
              // }
            },
            labelLine: {
              show: true
            },
            labelLayout: (params) => {
              const isLeft = params.labelRect.x < ds / 2
              // points：labelLine的三个点坐标，改变第三个点的x坐标，增加length2的长度，达到label在labelLine线上
              const points = params.labelLinePoints
              if (isLeft) { // 左边
                points[2][0] = params.labelRect.x
              } else {
                points[2][0] = params.labelRect.x + params.labelRect.width
              }
              return {
                labelLinePoints: points
              }
            },
            data: values
          }
        ]
      }
      return o
    },
    initChart() {
      log(`initChart`)
      const { id } = this
      const canvasid = `wtpie_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt(this.values)
        
        myChart.setOption(opt)
        
        // 默认选中高亮
        const index = 0
        // myChart.dispatchAction({
        //   type: 'select',
        //   dataIndex: index
        // })
        // highlight后，才会显示标线这些,并且进行放大
        myChart.dispatchAction({
          type: 'highlight',
          dataIndex: 0
        })
        
        this._myChart = myChart
      } catch (err) {
        error('被捕获:' + err)
      }      
    },
    updateChart() {
      log(`updateChart, values: ${this.values}`)
      const myChart = this._myChart
      const newOpt = this.getOpt(this.values)
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
.pie-ctn {
    display: inline-block;
    @include bBox;
}
</style>
